import React from 'react'
import Button from '@mui/material/Button'
function SmallFormSubmitButton({ onClickHandler, buttonText }) {
    return (
        <Button className='btn-primary' sx={{
            backgroundColor: 'green',
            color: 'white',
            borderRadius: '8px',
            fontFamily: 'Lato',
            fontWeight: '400',
            minWidth: 'fit-content',
            width: '20%',
            maxWidth: '-webkit-fill-available',
            height: '3rem',
            margin: '0 0.5rem',
            maxHeight: '4rem',
            '&:hover': {
                backgroundColor: 'green', // This keeps the button green on hover
            },
        }}
            onClick={onClickHandler}>
            {buttonText}
        </Button>
    )
}

export default SmallFormSubmitButton